import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  HostListener,
  Renderer2
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Directive({
  selector: 'rad-radio-group',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: RadRadioDirective,
      multi: true
    }
  ]
})
export class RadRadioDirective implements ControlValueAccessor {
  constructor(private element: ElementRef, private renderer: Renderer2, private cdr: ChangeDetectorRef) {
    this.onChange = () => {};
    this.onTouched = () => {};
  }

  onChange: (value: string) => void;
  onTouched: () => void;

  writeValue(value: string) {
    this.renderer.setProperty(this.element.nativeElement, 'value', value);
  }

  @HostListener('change', ['$event.detail'])
  _handleChange(detail: any) {
    if (detail.value) {
        this.onChange(detail.value);
        this.cdr.detectChanges();
    }
  }


  registerOnChange(fn: (value: string) => void) {
    this.onChange = (event) => {
      fn(event);
    };
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.element.nativeElement, 'disabled', isDisabled);
  }

}
